import React, { useState, useEffect, useLayoutEffect } from "react";
import { Wrapper } from "./Priority.styled";
import { Select } from 'antd';
import { Row, Col, Spin, Button, ErrorNotification } from "components/common";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PriorityCardEntity from "components/pageSection/Priority/PriorityCardEntity/PriorityCardEntity";
import {
  callGetApi,
  callPostApi,
} from "utils/api";
import { LoadingOutlined } from '@ant-design/icons';
import { FaSearchLocation, FaUser, FaUserCheck } from 'react-icons/fa';
import { BiReset } from 'react-icons/bi';
import UserIcon from "../../assets/svg/boy-avatar.svg";
import PriorityCardEntitySm from "components/pageSection/Priority/PriorityCardEntitySm/PriorityCardEntitySm";

const { Option } = Select;

const CustomStyles = {
  spin: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 20,
  },
  multiPadding: { padding: 24, paddingTop: 24, paddingBottom: 30 },
  paddingZero: { padding: 0 },
  bgColor: { backgroundColor: '#131f28' },
  positionInherit: { position: 'inherit' }
}

const Priority = () => {
  const DEFAULT_COLOR = '#000000';
  const DEFAULT_COLOR_HEX = ['AA', 'BB', 'CC', 'DD', 'EE', 'FF']
  const [locationId, setLocationId] = useState("");
  const [location, setLocation] = useState([]);
  const [accessLevel, setAccessLevel] = useState([]);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [users, setUsers] = useState([]);
  const [availableUser, setAvailableUser] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [interval, setInterval] = useState([]);
  const [intervalReverse, setIntervalReverse] = useState([]);
  const [repId, setRepId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isAddUserLoading, setIsAddUserLoading] = useState(false);

  const antIcon = <LoadingOutlined style={{ color: 'white', fontSize: 24 }} spin />;

  const createBorderColor = (length) => {
    let colorList = []
    for (let i = 0; i < length; i++) {
      if (i === 0) {
        let co = DEFAULT_COLOR.slice(0, 5)
        colorList.push(`${co}33`)
      } else {
        let last = colorList[colorList.length - 1];
        let co = last.slice(5)
        if (DEFAULT_COLOR_HEX.includes(co)) {
          if (co !== 'FF') {
            let indexOf = DEFAULT_COLOR_HEX.indexOf(co);
            colorList.push(`${last.slice(0, 5)}${DEFAULT_COLOR_HEX[indexOf + 1]}`)
          }
        } else {
          co = parseInt(co);
          if (co + 33 <= 99) {
            colorList.push(`${last.slice(0, 5)}${co + 33}`)
          } else {
            colorList.push(`${last.slice(0, 5)}AA`)
          }
        }
      }
    }
    let copyList = [...colorList];
    copyList.reverse();
    setInterval(copyList);
    setIntervalReverse(colorList)
  }
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const selectAvaliableUser = (id) => {
    if (selectedUser === id) {
      setSelectedUser('')
    } else {
      setSelectedUser(id);
    }
  }
  const onEnd = async (result) => {
    if (!result.destination) {
      return;
    }
    if (result.source.droppableId === "dropableid-assigned" && result.source.droppableId === result.destination.droppableId) {
      handleProiorityChangeAssignedUsers(result);
    }
    if (result.source.droppableId === "dropableid-assigned" && result.destination.droppableId === "dropableid-avaiable") {
      handleAssignedToAvaiableDrop(result);
    }
    if (result.source.droppableId === "dropableid-avaiable" && result.destination.droppableId === "dropableid-assigned") {
      handleAvaiableToAssignedDrop(result);
    }
    if (result.source.droppableId === "dropableid-assigned" && result.destination.droppableId === "dropableid-avaiable-sm") {
      handleAssignedToAvaiableDrop(result);
    }
    if (result.source.droppableId === "dropableid-avaiable-sm" && result.destination.droppableId === "dropableid-assigned") {
      handleAvaiableToAssignedDrop(result);
    }
  };
  const handleAssignedToAvaiableDrop = (result) => {
    const assigned = users[result.source.index];
    const filterAssigned = users.filter((u) => u._id !== assigned._id);
    setUsers(filterAssigned);
    setAvailableUser((prev) => ([assigned, ...prev]))
    deleteUserFromRotation(assigned._id)
  };
  const handleAvaiableToAssignedDrop = (result) => {
    const available = availableUser[result.source.index - users.length];
    const filterAvailables = availableUser.filter((u) => u._id !== available._id);
    setAvailableUser(filterAvailables);
    setUsers((prev) => ([available, ...prev]))
    setSelectedUser(available._id);
    addUser(available._id);

  };
  const handleProiorityChangeAssignedUsers = (result) => {
    let newDupldateValue = [];
    if (result.source.index != result.destination.index) {
      if (result.source.index < result.destination.index) {
        for (let i = result.source.index; i <= result.destination.index; i++) {
          if (i == result.destination.index) {
            let index1 = users[result.source.index];
            let index2 = users[result.destination.index];
            let data_1 = {
              userId: index1?._id,
              priority: index2?.priority,
              allotCount: index1?.allotCount,
              name: index1?.username,
              count: index1?.count
            };
            newDupldateValue.push(data_1);
          } else {
            let index1 = users[i];
            let index2 = users[i + 1];
            let data_1 = {
              userId: index2?._id,
              priority: index1?.priority,
              allotCount: index2?.allotCount,
              name: index2?.username,
              count: index2?.count
            };
            newDupldateValue.push(data_1);
          }
        }
      } else {
        for (let i = result.source.index; i >= result.destination.index; i--) {
          if (i == result.destination.index) {
            let index1 = users[result.source.index];
            let index2 = users[result.destination.index];
            let data_1 = {
              userId: index1?._id,
              priority: index2?.priority,
              allotCount: index1?.allotCount,
              name: index1?.username,
              count: index1?.count
            };
            newDupldateValue.push(data_1);
          } else {
            let index1 = users[i];
            let index2 = users[i - 1];
            let data_1 = {
              userId: index2?._id,
              priority: index1?.priority,
              allotCount: index2?.allotCount,
              name: index2?.username,
              count: index2?.count
            };
            newDupldateValue.push(data_1);
          }
        }
      }
    }
    if (newDupldateValue.length) {
      postPriorityChange(newDupldateValue);
      setUsers(
        reorder(users, result.source.index, result.destination.index)
      );
    }
  }

  // API's
  const getUserApi = (id) => {
    callGetApi(`/priority/all/closers/${id}`, (data) => {
      createBorderColor(data.usersAssigned.length);
      setUsers(data.usersAssigned);
      setAvailableUser(data.usersAvailable);
      setIsLoading(false);
      setSelectedUser('');
    }, (err) => {
      setIsLoading(false);
      console.log(err);
    });
    setIsLoading(true);
  };
  const getUserApiWithoutLoader = () => {
    callGetApi(`/priority/all/closers/${locationId}`, (data) => {
      createBorderColor(data.usersAssigned.length);
      setUsers(data.usersAssigned);
      setAvailableUser(data.usersAvailable);
      setIsLoading(false);
      setSelectedUser('');
    }, (err) => {
      setIsLoading(false);
      console.log(err);
    });
  };
  const getLocationApi = () => {
    callGetApi("/location", (data) => {
      setLocation(data);
      setLocationId(data[0]?._id);
      getUserApi(data[0]?._id);
    }, (err) => { });
  };
  const getAccessLevelApi = () => {
    callGetApi("/roles", (data) => {
      data?.map((el) => {
        if (el.role == "Rep") {
          setRepId(el._id);
        }
      });
      setAccessLevel(data);
    }, (err) => {
      console.log(err);
    });
  };
  const getResetApi = () => {
    callGetApi("/priority/all/closers/reset/count", (data) => {
      getUserApi(locationId);
    }, (err) => {
      console.log(err);
    });
  };
  const postPriorityChange = (data) => {
    callPostApi("/priority/update/priority/list", { data },
      () => {
        getUserApi(locationId);
      },
      () => { }
    );
  }
  const deleteUserFromRotation = (id) => {
    callPostApi('/priority/remove/user/from/the/rotation/list', { userId: id },
      () => { getUserApi(locationId); setIsLoading(false); },
      (err) => { console.log(err); setIsLoading(false); }
    )
  }
  const addUser = (id) => {
    setIsAddUserLoading(true);
    callPostApi("/priority/update/user/location/to/current", { userId: id, locationId },
      () => { setIsAddUserLoading(false); getUserApi(locationId); },
      () => { setIsAddUserLoading(false); ErrorNotification("Failed To Add User to location"); }
    );
  }

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 991) {
        setIsSmallScreen(true);
      } else {
        return setIsSmallScreen(false);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  useEffect(() => {
    if (locationId) {
      getUserApi(locationId)
    }
  }, [locationId, location, repId]);

  useEffect(() => {
    getLocationApi();
    getAccessLevelApi();
  }, []);

  const onBlur = (event) => {
    console.log("Blur => ", event)
  }
  const onFocus = (event) => {
    console.log("Focus => ", event)
  }

  return (
    <Wrapper>
      <DragDropContext onDragEnd={onEnd} >
        <Row gutter={[0, 15]} style={CustomStyles.paddingZero}>
          <Col xs={24} sm={24} lg={22} xl={22} xxl={22} style={CustomStyles.multiPadding}>
            <div className="search-container">
              <div className="search-select">
                <div className="icon">
                  <FaSearchLocation size={isSmallScreen ? 16 : 20} />
                </div>
                <Select value={locationId} onChange={(value) => setLocationId(value)} placeholder="Locations" className="select" >
                  {location?.map((l) => (
                    <Option key={l._id} value={l._id}>{l.name}, {l.state}</Option>
                  ))}
                </Select>
              </div>
              <button className="button-reset" onClick={getResetApi} style={{ fontSize: isSmallScreen ? 12 : 16 }}>
                <BiReset size={isSmallScreen ? 18 : 22} className="btn-icon" />
                Reset Rotation
              </button>
            </div>

            <div className="page-title">
              <FaUser size={24} />
              <div className="text">Rotation</div>
            </div>
            <div className="content">

              {!isLoading && availableUser && availableUser.length ? (
                <div className="mt-4">
                  <PriorityCardEntity
                    data={{}}
                    getUserApi={getUserApiWithoutLoader}
                    borderColor="#0066CC"
                    color="#000033"
                    setIsAddUserLoading={setIsAddUserLoading}
                    isAddUserLoading={isAddUserLoading}
                    isDropAble={true}
                    isSmallScreen={isSmallScreen}
                    selectedUser={selectedUser}
                    locationId={locationId}
                    isAdd={selectedUser ? true : false}
                  />
                  <hr />
                </div>
              ) : null}
              {isLoading ? (<div style={CustomStyles.spin}> <Spin /> </div>) : (
                <Droppable droppableId="dropableid-assigned">
                  {(provided, snapshot) => (
                    <div ref={provided.innerRef} className="rotation-continer">
                      {users?.map((item, index) => (
                        <Draggable draggableId={item._id} key={item._id} index={index}>
                          {(provided, snapshot) => (
                            // <div className="container-one">
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              onFocus={onFocus}
                              onBlur={onBlur}
                            >
                              <PriorityCardEntity
                                isDragging={snapshot.isDragging}
                                data={item}
                                getUserApi={getUserApiWithoutLoader}
                                borderColor={interval[index]}
                                color={intervalReverse[index]}
                                isSmallScreen={isSmallScreen}
                              />
                              {provided.placeholder}
                            </div>
                            // </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              )}
            </div>
          </Col>
          <Col xs={24} sm={24} lg={2} xl={2} xxl={2} style={CustomStyles.positionInherit}>
            {!isSmallScreen && (<div className="users-container">
              <div className="top-icon">
                <FaUserCheck size={40} color="white" />
              </div>
              {isLoading ? (<div style={CustomStyles.spin}> <Spin indicator={antIcon} /> </div>) : (
                <>
                  {availableUser && availableUser.length ? (
                    <Droppable droppableId="dropableid-avaiable">
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef} className="available-user">
                          {
                            availableUser.map((user, index) => (
                              <Draggable draggableId={user._id} key={user._id} index={users.length + index} >
                                {(provided, snapshot) => (
                                  <>
                                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                      <PriorityCardEntitySm
                                        isDragging={snapshot.isDragging}
                                        isSmall={isSmallScreen}
                                        user={user}
                                        selectAvaliableUser={selectAvaliableUser}
                                        selectedUser={selectedUser}
                                      />
                                    </div>
                                    {provided.placeholder}
                                  </>
                                )}
                              </Draggable>
                            ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  ) : (<div className="empty-user-list">No avaiable user.</div>)}
                </>
              )}
            </div>)}
            {isSmallScreen && (
              <div className="user-small-container">
                <div className="top-icon">
                  <FaUserCheck size={35} color="white" />
                </div>
                {isLoading ? (<div style={CustomStyles.spin}> <Spin indicator={antIcon} /> </div>) : (
                  <>
                    {availableUser && availableUser.length ? (
                      <Droppable droppableId="dropableid-avaiable-sm">
                        {(provided, snapshot) => (
                          <div ref={provided.innerRef} className="available-user-sm">
                            {availableUser.map((user, index) => (
                              <Draggable draggableId={user._id} key={user._id} index={users.length + index} >
                                {(provided, snapshot) => (
                                  <>
                                    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                      <PriorityCardEntitySm
                                        isDragging={snapshot.isDragging}
                                        isSmall={isSmallScreen}
                                        user={user}
                                        selectAvaliableUser={selectAvaliableUser}
                                        selectedUser={selectedUser}
                                      />
                                    </div>
                                    {provided.placeholder}
                                  </>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    ) : (<div className="empty-user-list-sm">No available user.</div>)}
                  </>
                )}
              </div>
            )}
          </Col>
        </Row>
      </DragDropContext>
    </Wrapper>
  );
};

export default Priority;
